module.exports = __webpack_public_path__ + "img/7step-02-01-1_ergebnis.9a3ae10c.png";